<template>
    <div id="course" class="app-inner">
         <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addCourse">
        新增证书
      </div>
    </div>
    <div class="p-tit-c">
        <div class="businessList-filter">
              <div class="businessList-filter-list flex align-cen">
                   <div class="fl-le flex align-cen">
          <div class="label">证书名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入证书名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">证书ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输证书ID" v-model="search1" clearable> </el-input>
          </div>
         </div> 
              </div>
             <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">证书分类：</div>
                     <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
                    <div class="label">启用状态：</div>
                    <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                    @click="allradio"
                    >
                    不限
                    </div>
                    <el-radio v-model="radio" label="1" @change="classSelect" >启用</el-radio>
                    <el-radio v-model="radio" label="0" @change="classSelect">禁用</el-radio>
                </div>
    <div class="businessList-filter-list flex align-cen">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="classSelect"
        >
        </el-date-picker>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件
        </div>
      </div>
        </div>
    </div>
         <div class="businessList-container">
        <div class="businessList-container-table">
          <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
         <el-table-column prop="name" label="证书名称" align="center" width="250">
          </el-table-column>
          <el-table-column prop="id" label="证书ID" align="center" width="200">
          </el-table-column>
              <el-table-column prop="classifyName" label="证书类型" align="center" width="200">
          </el-table-column>
             <el-table-column prop="receiveNum" label="领取人数" align="center" >
          </el-table-column>
             <el-table-column prop="sort" label="排序" align="center">
          </el-table-column>
             <el-table-column label="启用状态" align="center" width="150">
            <template slot-scope="scope">
              <div class="buStatus"  @click="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
             <el-table-column prop="createTime" label="创建时间" align="center" width="200">
          </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            width="300"
            >
             <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="previewCourse(scope.row)">预览</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="opeRecip(scope.row)">查看证书领取人</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="addCourse(scope.row)">编辑</el-button> 
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="deleteCertf(scope.row)">删除</el-button> 
            </template>
          </el-table-column>
      </el-table>
       <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
         </div>
    </div>
</template>
<script>
import {getAllCertClassify,getcertList,editCertificate,deletCertificate} from "@/api/index/index"  //证书分类、证书列表、删除证书
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    components:{
      paginaTion
    },
    data () {
        return {
            search:'',
            search1:'',
            itemList:[],
            value:'',
            value2:'',
            radio:'',
            list:[],
            start_time:'',
            end_time:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
             },
        }
    },
    activated() {
        this.getList()
    },
    created () {
        this.getCourseClass()
    },
    methods: {
         emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
        changeStatus(e){
            if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '证书禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.editPaper(e)
        }
        },
          editPaper(e){
             editCertificate({
                id:e.row.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                    this.getList()
                  }
                })
                .catch(err => {
                })
        },
        // 证书列表
        getList(){
            let params = {
                name:this.search,
                id:this.search1,
                classifyId:this.value,
                state:this.radio,
                createTimeStart:this.start_time,
                createTimeEnd:this.end_time,
                size:this.PageSize,
                current:this.currentPage,
            }
            getcertList(params)
            .then(res => {
            this.list = res.data.records
            this.totalCount = res.data.total
          })
          .catch(err => {})

        },
        reset(){
         this.search1=""
          this.search=""
          this.value=""
          this.radio=""
          this.start_time=""
          this.end_time=""
          this.value2 = ''
          this.currentPage=1
          this.getList()
        },
        // 筛选
        allradio(){
         this.radio = ""
        this.currentPage = 1
        this.getList()
        },
        classSelect(){
         if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
          this.currentPage = 1
          this.getList()
        },
        // 获取题目分类
          getCourseClass(){
            this.itemList = []
             getAllCertClassify({
                name:''
             })
            .then(res => {
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 删除证书
        deleteCertf(data){
             this.$confirm('确定要删除该证书吗？删除后不可恢复，请您谨慎操作', '删除证书', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  deletCertificate({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
        },
        // 打开新增证书窗口
        addCourse(data){
            this.$router.push({
        name: "certAdd",
        query:{
            id:data.id,
        }
        })
        },
        //预览证书
        previewCourse(data){
        this.$router.push({
        name: "previewCert",
        query:{
            id:data.id,
        }
        })
        },
        // 查看证书领取人
        opeRecip(data){
        this.$router.push({
        name: "certificateRecipient",
        query:{
            id:data.id,
        }
        })
        },
    },
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
    ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
}
</style>